<template>
  <div class="u-flex-y u-flex-items-center" style="background: #F7F8FA;">
    <Nav></Nav>
    <div style="height: 80px"></div>
    <div class="scopeDetailsBox">
      <div class="u-flex u-flex-items-center" style="margin: 12px 0;">
        <div @click="changetabs(1)" :class="tabIndex == 1?'activeItem':''" class="ChangeItem">
          让球
        </div>
        <div @click="changetabs(2)" :class="tabIndex == 2?'activeItem':''" class="ChangeItem">
          胜负
        </div>
        <div @click="changetabs(3)" :class="tabIndex == 3?'activeItem':''" class="ChangeItem">
          进球数
        </div>
      </div>
      <div class="tableData">
        <div class="u-flex myheader">
          <div class="headerName">
            比分
          </div>
          <div class="headerName">
              <span v-if="tabIndex == 1">
                主队
              </span>
              <span v-if="tabIndex == 2">
                主胜
              </span>
              <span v-if="tabIndex == 3">
                大球
              </span>
          </div>
          <div class="headerName"> 走势
          </div>
          <div class="headerName">
            <span v-if="tabIndex == 1">
              客队
            </span>
            <span v-if="tabIndex == 2">
              客胜
            </span>
            <span v-if="tabIndex == 3">
              小球
            </span>
          </div>
          <div class="headerName"> 更新
          </div>
        </div>
        <div class="Header_list" v-if="tabIndex == 1 ">
          <div class="data_box" v-for="(item,index) in FlowList1" :key="index">
            <div class="data_item dataItemfirstChild mytime">
              {{fifscope(item)}}
            </div>
            <div class="contentval" v-if="item.isEntertained != 2">
              <div class="data_item" :class="{'redUp':item.homeUp ===1,'greenUp':item.homeUp ===2}">
                {{item.homeOdds | tofix(item.homeOdds)}}
                <img v-if="item.homeUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                <img v-if="item.homeUp ==2" src="/static/scope/shang.png" alt="" srcset="">
              </div>
              <div class="data_item" :class="{'redUp':item.goalUp ===1,'greenUp':item.goalUp ===2}">
                {{item.goal | tofix(item.goal)}}
              </div>
              <div class="data_item" :class="{'redUp':item.awayUp ===1,'greenUp':item.awayUp ===2}">
                {{item.awayOdds | tofix(item.awayOdds)}}
                <img v-if="item.awayUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                <img v-if="item.awayUp ==2" src="/static/scope/shang.png" alt="" srcset="">
              </div>
            </div>
            <div class="contentval" style="border-right: 1px solid rgba(0,0,0,.1);" v-else>
              封
            </div>
            <div class="data_item mytime" v-if="item.type == 4 && item.changeTime">
              {{item.nowMatchTime}}`
            </div>
            <div class="data_item mytime" v-else>
              {{fifDate(item)}}
            </div>
          </div>
        </div>
        <div class="Header_list" v-if="tabIndex == 2 ">
          <div class="data_box" v-for="(item,index) in FlowList2" :key="index">
            <div class="data_item dataItemfirstChild mytime">
              {{fifscope(item)}}
            </div>

            <div class="contentval" v-if="item.isEntertained != 2">
              <div class="data_item" :class="{'redUp':item.homeUp ===1,'greenUp':item.homeUp ===2}">
                {{item.homeOdds| tofix(item.homeOdds)}}
                <img v-if="item.homeUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                <img v-if="item.homeUp ==2" src="/static/scope/shang.png" alt="" srcset="">
              </div>
              <div class="data_item" :class="{'redUp':item.goalUp ===1,'greenUp':item.goalUp ===2}">
                {{item.flatOdds | tofix(item.flatOdds)}}
              </div>
              <div class="data_item" :class="{'redUp':item.awayUp ===1,'greenUp':item.awayUp ===2}">
                {{item.awayOdds | tofix(item.awayOdds)}}
                <img v-if="item.awayUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                <img v-if="item.awayUp ==2" src="/static/scope/shang.png" alt="" srcset="">
              </div>
          <!--    <div class="data_item mytime" v-if="item.type == 4 && item.changeTime">
                {{item.nowMatchTime}}`
              </div> -->
            </div>
            <div class="contentval" style="border-right: 1px solid rgba(0,0,0,.1);" v-else>
              封
            </div>

            <div class="data_item mytime" v-if="item.type == 4 && item.changeTime">
              {{item.nowMatchTime}}`
            </div>
            <div class="data_item mytime" v-else>
              {{fifDate(item)}}
            </div>
          </div>
        </div>

        <div class="Header_list" v-if="tabIndex == 3 ">
          <div class="data_box" v-for="(item,index) in FlowList3" :key="index">
            <div class="data_item dataItemfirstChild mytime">
              {{fifscope(item)}}
            </div>

            <div class="contentval" v-if="item.isEntertained != 2">
              <div class="data_item" :class="{'redUp':item.homeUp ===1,'greenUp':item.homeUp ===2}">
                {{item.upOdds}}
                <img v-if="item.homeUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                <img v-if="item.homeUp ==2" src="/static/scope/shang.png" alt="" srcset="">
              </div>
              <div class="data_item" :class="{'redUp':item.goalUp ===1,'greenUp':item.goalUp ===2}">
                {{item.goal}}
              </div>
              <div class="data_item" :class="{'redUp':item.awayUp ===1,'greenUp':item.awayUp ===2}">
                {{item.downOdds}}
                <img v-if="item.awayUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                <img v-if="item.awayUp ==2" src="/static/scope/shang.png" alt="" srcset="">
              </div>
            </div>
            <div class="contentval" style="border-right: 1px solid rgba(0,0,0,.1);" v-else>
              封
            </div>
            <div class="data_item mytime" v-if="item.type == 4 && item.changeTime">
              {{item.nowMatchTime}}`
            </div>
            <div class="data_item mytime" v-else>
              {{fifDate(item)}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from "../../component/Nav.vue";
  import {
    asiaFlowList,
    bsFlowList,
    europeFlowList
  } from '@/api/scope.js';
  import moment from 'moment';
  export default {
    name: 'helpDown',
    data() {
      return {
        tabIndex: 1,
        matchInfo: {},
        FlowList1: [],
        FlowList2: [],
        FlowList3: []
      };
    },
    created() {
      let {
        matchId,
        companyId
      } = this.$route.query
      console.log('参数', matchId, companyId);
      if (matchId && companyId) {
        this.matchInfo = {
          matchId,
          companyId
        };
        this.changetabs(1)
      }
    },
    filters:{
      tofix(val){
        if(val){
          return val.toFixed(2)
        }
      }
    },
    methods: {

      fifDate(item) {
        return moment.unix(item.changeTime).format('YYYY-MM-DD HH:mm')
      },
      fifscope(item) {
        if (item.type == 1) {
          return '-'
        }
        if (item.type == 2) {
          return '早'
        }
        if (item.type == 3) {
          return '即'
        }
        if (item.type == 4) {
          return `${item.homeScore} - ${ item.awayScore }`;
        }
      },
      fifrequestData() {
        if (this.tabIndex == 1) {
          this.FlowList1.map((item, index, arr) => {
            item.homeUp = 0
            item.awayUp = 0
            item.goalUp = 0
            if (index < arr.length - 1) {
              // 下一条数据
              let nextVal = arr[index + 1];

              // 主队胜率
              if (item.homeOdds > nextVal.homeOdds) {
                item.homeUp = 1
              }

              if (item.homeOdds < nextVal.homeOdds) {
                item.homeUp = 2
              }


              // 客队胜率
              if (item.awayOdds > nextVal.awayOdds) {
                item.awayUp = 1
              }
              if (item.awayOdds < nextVal.awayOdds) {
                item.awayUp = 2
              }

              // 盘口(让球-亚盘)
              if (item.goal > nextVal.goal) {
                item.goalUp = 1
              }
              if (item.goal < nextVal.goal) {
                item.goalUp = 2
              }
            }
            return item
          })
        }
        if (this.tabIndex == 2) {
          this.FlowList2.map((item, index, arr) => {
            item.homeUp = 0
            item.awayUp = 0
            item.goalUp = 0
            if (index < arr.length - 1) {
              // 下一条数据
              let nextVal = arr[index + 1];
              // 主队胜率
              if (item.homeOdds > nextVal.homeOdds) {
                item.homeUp = 1
              }
              if (item.homeOdds < nextVal.homeOdds) {
                item.homeUp = 2
              }
              // 客队胜率
              if (item.awayOdds > nextVal.awayOdds) {
                item.awayUp = 1
              }
              if (item.awayOdds < nextVal.awayOdds) {
                item.awayUp = 2
              }

              // 盘口(让球-亚盘)
              if (item.flatOdds > nextVal.flatOdds) {
                item.goalUp = 1
              }
              if (item.flatOdds < nextVal.flatOdds) {
                item.goalUp = 2
              }


            }
            return item
          })
        }

        if (this.tabIndex == 3) {
          this.FlowList3.map((item, index, arr) => {
            item.homeUp = 0
            item.awayUp = 0
            item.goalUp = 0
            if (index < arr.length - 1) {
              // 下一条数据
              let nextVal = arr[index + 1];
              // 主队胜率
              if (item.upOdds > nextVal.upOdds) {
                item.homeUp = 1
              }
              if (item.upOdds < nextVal.upOdds) {
                item.homeUp = 2
              }
              // 客队胜率
              if (item.downOdds > nextVal.downOdds) {
                item.awayUp = 1
              }
              if (item.downOdds < nextVal.downOdds) {
                item.awayUp = 2
              }
              // 盘口(让球-亚盘)
              if (item.goal > nextVal.goal) {
                item.goalUp = 1
              }
              if (item.goal < nextVal.goal) {
                item.goalUp = 2
              }
            }
            return item
          })
        }
      },
      changetabs(e) {
        console.log('切换', e);
        this.tabIndex = e;
        if (e == 1) {
          asiaFlowList(this.matchInfo).then(res => {
            this.FlowList1 = res.data.data;
            console.log('让球--亚盘 ', res.data.data);
            this.fifrequestData()
          })
        }
        if (e == 2) {
          europeFlowList(this.matchInfo).then(res => {
            console.log('胜负-欧赔', res.data.data);
            this.FlowList2 = res.data.data;
            this.fifrequestData()
          })
        }
        if (e == 3) {
          bsFlowList(this.matchInfo).then(res => {
            console.log('进球数-大小球', res.data.data);
            this.FlowList3 = res.data.data;
            this.fifrequestData()
          })
        }
      }
    },
    components: {
      Nav,
    },
  };
</script>

<style lang='scss' scope>
  @import '../../assets/style/flex.scss';

  .scopeDetailsBox {
    max-width: 1200px;
    width: 100%;

    .redUp {
      color: red !important;
    }

    .greenUp {
      color: green !important;
    }

    .mytime {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999 !important;
    }

    .contentval {
      flex: 3;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      font-size: 14px;
      color: #333;
    }

    .Header_list {
      .data_box {
        height: 38px;
        display: flex;
        border-bottom: 1px solid rgba(0, 0, 0, .1);

        .dataItemfirstChild {
          border-left: 1px solid rgba(0, 0, 0, .1);
          width: 180px;
          max-width: 180px;
          height: 38px;
        }

        .data_item {
          flex: 1;
          height: 38px;
          line-height: 38px;
          text-align: center;
          background-color: #fff;
          border-right: 1px solid rgba(0, 0, 0, .1);
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333;

          img {
            height: 14px;
            width: 14px;
          }
        }
      }

    }

    .tableData {
      display: flex;
      flex-direction: column;

      .myheader {
        border-top: 1px solid #DADADA;
        border-bottom: 1px solid #DADADA;
        border-left: 1px solid #DADADA;
        height: 42px;
      }

      .headerName:first-child {
        /* border-left: 1px solid rgba(0,0,0,.1); */
        max-width: 180px;
        height: 42px;
      }

      .headerName {
        flex: 1;
        height: 42px;
        line-height: 38px;
        text-align: center;
        background-color: #F6F0FF;
        border-right: 1px solid rgba(0, 0, 0, .1);

        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

    }

    .activeItem {
      background: #721EDC !important;
      transition: all .2s;
      color: #fff !important;
    }

    .ChangeItem {
      width: 80px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px;
      margin-right: 12px;
      cursor: pointer;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/scopeDetails.vue